<template>
  <div class="content octopart-parts-table" id="octopart-parts">
    <!-- <Input search enter-button placeholder="Search MPN on Octopart" v-model="keyword" @on-search="handleSearch"/> -->
     <Alert v-show="!mpn">
       {{ $t('electronic.octopart_search.performan_mpn_search_info') }}</Alert>
     <vxe-grid
        border='inner'
        resizable
        stripe
        showOverflow
        :data="tableData"
        :loading="loading"
        :columns="columns"
        ref="components"
        column-min-width="50"
        size="mini"
        row-id="id"
        :checkbox-config="{trigger: 'row', checkMethod: allowTransfer}"
        @checkbox-change="handleCheckonComponent"
        >
        <template v-slot:property="{row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex}">
          <span>
            {{_.get(row, column.props.spec)}}
          </span>
        </template>
        <template v-slot:spec-display-value="{column, row}">
          {{ getSpecValue(row, column.params.id) }}
        </template>
      </vxe-grid>
      <Button v-if="showTransferButton"
        type="primary"
        class="margin-top-10"
        :disabled="selectedComponets.length === 0"
        @click="handleTransferComponent"
        id="transfer-item">{{ $t('electronic.button.octopart_add') }}</Button>
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)
export default {
  name: 'OctopartSearchPart',
  props: {
    components: {
      type: Array
    },
    mpn: {
      type: String,
      required: false
    },
    brand: {
      type: String,
      required: false
    },
    showTransferButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keyword: null,
      loading: false,
      mainColumns: [
        { type: 'checkbox', field: 'id', title: 'Select', width: 80, fixed: 'left' },
        { field: 'mpn', title: 'MPN', minWidth: 200, remoteSort: false, fixed: 'left' },
        { field: 'original.manufacturer.name', title: 'Manufacturer', minWidth: 120, remoteSort: false, fixed: 'left' },
        { field: 'category.name', title: 'Category', minWidth: 140, remoteSort: false },
        { field: 'specification', title: 'Specification', minWidth: 350, remoteSort: false },
        { field: 'description', title: 'Description', minWidth: 300, remoteSort: false }
      ],
      columns: [],
      specColumns: [],
      actionColumns: [],
      tableData: [],
      selectedComponets: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions([
      'searchOctopartComponent',
      'transferOctopartComponent'
    ]),
    async init() {
      this.selectedComponets = []
      this.specColumns = []
      this.tableData = []
      this.columns = _.concat(this.mainColumns, this.specColumns, this.actionColumns)
    },
    handleSearch (mpn, brand) {
      if (mpn) {
        this.loading = true
        this.searchOctopartComponent({
          mpn: mpn,
          brand: brand || null
        }).then(res => {
          this.generateSpecColumns(res)
          this.tableData = res
          this.$emit('onSearchComplete', res)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleCheckonComponent({ records, reserves, indeterminates, checked, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }) {
      this.selectedComponets = records
      this.$emit('update:components', this.selectedComponets)
    },
    async handleTransferComponent() {
      if (this.selectedComponets.length > 0) {
        this.loading = true
        let result = await this.transferOctopartComponent(this.selectedComponets).then(res => {
          this.$emit('onTransfered', res)
          return res
        }).finally(() => {
          this.loading = false
        })
        return result
      }
      return null
    },
    getSpecValue(component, specAttributeId) {
      let findSpec = _.find(component.original.specs, (spec) => {
        return spec.attribute.id === specAttributeId
      })
      if (findSpec) {
        return findSpec.display_value
      }
      return null
    },
    findOrSetSpecColumn(specAttr) {
      let groupColumn = _.find(this.specColumns, (column) => {
        return column.title === specAttr.group
      })

      if (!groupColumn) {
        groupColumn = {
          title: specAttr.group,
          children: []
        }
        this.specColumns.push(groupColumn)
      }

      this.generateSpecColumnInGroup(groupColumn, specAttr)
    },
    generateSpecColumnInGroup(groupColumn, specAttr) {
      let fieldKey = 'original.specs.' + specAttr.shortname

      let findChildren = _.find(groupColumn.children, (column) => {
        return column.field === fieldKey
      })

      if (!findChildren) {
        groupColumn.children.push({
          field: fieldKey,
          title: specAttr.name,
          minWidth: 120,
          showHeaderOverflow: true,
          params: {
            id: specAttr.id
          },
          filters: [],
          visible: true,
          slots: {
            default: 'spec-display-value'
          }
        })
      }
    },
    async generateSpecColumns(components) {
      _.each(components, (component) => {
        _.each(component.original.specs, (spec) => {
          this.findOrSetSpecColumn(spec.attribute)
        })
      })
      this.$nextTick(() => {
        this.columns = _.concat(this.mainColumns, this.specColumns, this.actionColumns)
        this.$refs.components.refreshColumn()
      })
    },
    allowTransfer({ row }) {
      return !!row.category
    }
  }
}
</script>
